import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

export const CHART_COLORS = {
  purple: '#7c3aed',
  purpleLight: '#a78bfa',
  green: '#10b981',
  blue: '#3b82f6',
  cyan: '#06b6d4',
  amber: '#f59e0b',
  rose: '#B32025',
  pink: '#ec4899',
  yellow: '#fbbf24',
  gray: '#e5e7eb',
  grayDark: '#9ca3af'
};

export const defaultChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      labels: {
        color: '#4b5563',
        font: { size: 12, weight: '500' },
        usePointStyle: true,
        boxWidth: 8
      }
    },
    tooltip: {
      backgroundColor: '#1f2937',
      titleColor: '#f9fafb',
      bodyColor: '#f9fafb',
      padding: 12,
      cornerRadius: 8
    }
  }
};
